import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

const gallery = document.querySelector('.js-gallery');
const leftArrowSVGString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 18 12" width="18" height="12"><path d="M17.3285 5.00012V7.00012L4.50017 7.00012L7.7427 10.2426L6.32849 11.6569L0.671631 6L6.32849 0.343146L7.7427 1.75736L4.49994 5.00012L17.3285 5.00012Z" fill="#242424"/></svg>';
const CloseSVGString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 16 16" width="16" height="16">    <path d="M2.22526 0.811082C1.83474 0.420557 1.20158 0.420557 0.811051 0.811082C0.420527 1.20161 0.420527 1.83477 0.811051 2.2253L6.58579 8.00003L0.811111 13.7747C0.420587 14.1652 0.420587 14.7984 0.811111 15.1889C1.20164 15.5794 1.8348 15.5794 2.22532 15.1889L8 9.41424L13.7747 15.1889C14.1652 15.5794 14.7984 15.5794 15.1889 15.1889C15.5794 14.7984 15.5794 14.1652 15.1889 13.7747L9.41421 8.00003L15.1889 2.2253C15.5795 1.83477 15.5795 1.20161 15.1889 0.811082C14.7984 0.420557 14.1653 0.420557 13.7747 0.811082L8 6.58582L2.22526 0.811082Z" fill="white"/></svg>';

if(gallery) {

    const lightbox = new PhotoSwipeLightbox({
        bgOpacity: 0.9,
        closeSVG: CloseSVGString,
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: leftArrowSVGString,
        mainClass: 'custom-gallery',
        gallery: '.js-gallery',
        children: 'a',
        showHideAnimationType: 'fade',
        pswpModule: PhotoSwipe,
    });

    lightbox.init();

}
